<template>
    <div>
        <div class="opui-row">
            <div class="opui-col">
                <label>{{ $e('Choose funnel') }}</label>
                <RichSelect
                    v-if="trigger.settings"
                    v-model="trigger.settings.funnel_id"
                    modelValue="trigger.settings.funnel_id"
                    :settings="{ ajax: { url: this.restUrl('flow/funnels'), dataType: 'json' } }"
                    :ajaxUrl="restUrl('flow/funnels')"
                    :placeholder="'Select funnel'"
                    @select="funnelSelected"
                >
                    <option :value="trigger.settings.funnel_id" selected :key="trigger.settings.funnel_id" v-if="trigger.settings && trigger.settings.funnel_id">
                        {{ trigger.settings.funnel_title ? trigger.settings.funnel_title : trigger.settings.funnel_id }}
                    </option>
                </RichSelect>
            </div>
        </div>

        <div class="opui-row">
            <div class="opui-col" v-if="trigger.settings && trigger.settings.funnel_id && trigger.settings.funnel_id !== 'all'">
                <label>{{ $e('Choose funnel step') }}</label>
                <RichSelect
                    v-if="trigger.settings"
                    v-model="trigger.settings.funnel_step_id"
                    modelValue="trigger.settings.funnel_step_id"
                    :settings="{ ajax: { url: this.funnelStepUrl, dataType: 'json' } }"
                    :ajaxUrl="funnelStepUrl"
                    :placeholder="'Select funnel step'"
                    @select="funnelStepSelected"
                >
                    <option :value="trigger.settings.funnel_step_id" selected :key="trigger.settings.funnel_step_id" v-if="trigger.settings && trigger.settings.funnel_step_id">
                        {{ trigger.settings.funnel_step_title ? trigger.settings.funnel_step_title : trigger.settings.funnel_step_id }}
                    </option>
                </RichSelect>
            </div>
        </div>
    </div>
</template>

<script>
import RichSelect from "../../Global/RichSelect.vue"

export default {
    components: { RichSelect },
    props: {
        trigger:  { type: Object, required: true }
    },
    computed: {
        funnelStepUrl() {
            return this.restUrl('flow/funnel-steps?funnel_id=' + this.trigger.settings.funnel_id)
        }
    },
    methods: {
        /**
         * Update the selected text
         */
        funnelSelected(selected) {
            this.trigger.settings.funnel_title = selected.text
        },

        /**
         * Update the selected text for the funnel step
         */
        funnelStepSelected(selected) {
            this.trigger.settings.funnel_step_title = selected.text
        },
    }
}
</script>
